import { useBookingId } from "hooks/use-booking-id";
import { useCallback, useState } from "react";
import { BlockerFunction, Location, useBlocker } from "react-router-dom";
import { isGuid } from "utils";
import { useBookingStateContext } from "hooks/use-booking-state";
import { Routes } from "routes";
import { useReservation } from "api/api-hooks/use-create-reservation";

/**
 * Guard to prevent user from navigating away from cart with items
 */
export function useBookingGuard() {
    const bookingId = useBookingId();
    const { isActivityBooking, isWaitList } = useBookingStateContext();
    const { data: booking } = useReservation();

    // Keep and expose nextLocation to be used together with guard dialog component
    const [nextLocation, setNextLocation] = useState<Location | null>(null);

    const shouldBlock = useCallback<BlockerFunction>(
        ({ currentLocation, nextLocation }) => {
            // Reset next location initially
            setNextLocation(null);

            const typed = nextLocation as TypedHistory;

            const isNotUndefined = typed.state?.intercept !== undefined;
            if (!typed.state?.intercept && isNotUndefined) return false;

            const isCurrentFinalize = currentLocation.pathname.includes(Routes.FINALIZE);
            const isNextAvailability = nextLocation.pathname.includes(Routes.AVAILABILITY);
            const navigatinBackFromFinalize = isCurrentFinalize && isNextAvailability;

            if (isActivityBooking && isWaitList && navigatinBackFromFinalize) return true;

            if (!bookingId || booking?.isFinalized()) return false;

            const nextPath = nextLocation.pathname.split("/");

            if (!nextPath.some((path) => isGuid(path))) {
                setNextLocation(nextLocation);
                return true;
            }

            return false;
        },
        [bookingId, isActivityBooking, isWaitList, booking]
    );

    const blocker = useBlocker(shouldBlock);

    return { blocker, nextLocation };
}
